<template>
  <div>
    <Header />
    <section class="section-b-space">
      <div>
        <div>
          <div v-if="userRole === 'Partner'">
          <h3>My Profile</h3>
          <b-card>
            <b-row>
              <b-col md="4">
              <div style="text-align:center">
              <v-avatar size="120" style="z-index: 111;margin-bottom: -5%;">
                <img :src="userLogo" class="img-avatar" alt="user-logo" />
              </v-avatar>
             <div class="mt-4">
               <p> <b>Username :</b> {{ this.userInfo.authentication.userName }}</p>
               <div class="text-center mt-2">
                <v-btn
                  small
                  style="background-color:#727cf5;"
                  @click="
                    $router.push({
                      path: '/myaccount/viewprofile/edit-profile'
                    })
                  "
                  color="primary"
                  >Edit Profile</v-btn
                >
                <v-btn
                   small
                  style="background-color:#727cf5"

                    color="primary"
                    @click="$router.push({ path: '/myaccount/changepassword' })"
                  >
                    Change Password
                  </v-btn>
              </div>
             </div>
            </div>
              </b-col>
               <b-col md="8">
                 <h4 class="text-primary" >Personal Information</h4>
               <b-row>
                 <b-col md="6">
                 <p><b> E-mail : </b> {{ this.userInfo.authentication.email }}</p>
                 </b-col>
                 <b-col md="6">
                  <div>
                    <p><b>Phone : </b>{{ this.userInfo.authentication.phone }}</p>
                  </div>
                 </b-col>
               </b-row>
               <b-row v-if="this.userInfo.status" class="p-0 m-0">
                 <b-col md="6" class="p-0 m-0">
                   <p>Account Status : {{ this.userInfo.status }}</p>
                 </b-col>
               </b-row>
               <h4 class="text-primary">Address Information</h4>
               <b-row>
                 <b-col md="6">
                  <p><b>Country : </b>{{ this.userInfo.office.address.country }}</p>
                  <p><b>Street 1 : </b>{{ this.userInfo.office.address.street1 }}</p>
                  <p><b>House No : </b> {{ this.userInfo.office.address.houseNumber }}</p>
                 </b-col>
                 <b-col md="6">
                   <p><b>State : </b> {{ this.userInfo.office.address.state }}</p>
                   <p v-if="this.userInfo.office.address.street2"><b>Street 2 : </b>{{ this.userInfo.office.address.street2 }}</p>
                   <p><b>Zip : </b> {{ this.userInfo.office.address.zip }}</p>
                 </b-col>
               </b-row>
              </b-col>
            </b-row>
          </b-card>
          </div>
          <div>
            <b-tabs v-if="userRole === 'Tenant'">
                <b-card
                  style="width:1641px"
                  border-variant="info"
                  header-bg-variant="primary"
                  header-text-variant="white"
                  class="card-wrap"
                  header="Update Language Preference"
                >
                  <div>
                    <div>
                      <b-row>
                        <b-col>
                          <v-select
                            v-model="selectedLanguage"
                            :items="languages"
                            item-text="name"
                            item-value="id"
                            return-object
                            label="Select Language"
                            chips
                            multiple
                            hint="What are the target language"
                          ></v-select>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <v-select
                            :items="selectedLanguage"
                            item-text="name"
                            item-value="id"
                            v-model="defaultLanguage"
                            label="Default Language"
                            chips
                          ></v-select>
                        </b-col>
                      </b-row>
                      <b-row class="mt-1">
                        <b-col md="3">
                          <v-checkbox
                            v-model="lightMode"
                            label="Enable lightMode "
                          ></v-checkbox>
                        </b-col>
                        <b-col md="4">
                          <v-checkbox
                            v-model="enableManufacturer"
                            label="Enable Manufacturer "
                          ></v-checkbox>
                        </b-col>
                      </b-row>
                    </div>
                    <button
                      @click.prevent="onSaveLanguage"
                      type="button"
                      class="btn btn-solid btn-primary"
                    >
                      Save
                    </button>
                  </div>
                </b-card>
            </b-tabs>
          </div>
        </div>
      </div>
    </section>
    <Footer class="mt-5" />
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import { getReverseGeoCode } from "@/services/geocode";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      langObj: {
        en: "English",
        bn: "Bengali",
        te: "Telugu",
        hi: "Hindi"
      },
      lightMode: true,
      enableManufacturer: false,
      paramsId: null,
      isEditMode: false,
      oldPwd: "",
      newPwd: "",
      cfmPwd: "",
      errorMessages: "",
      details: {
        name: "",
        phone: "",
        email: ""
      },
      hasAddress: false,
      address: {
        city: "",
        country: "",
        houseNumber: "",
        state: "",
        street1: "",
        zip: "",
        location: {
          coordinates: [0, 0]
        }
      },
      selectedLanguage: [],
      defaultLanguage: "",
      languages: [
        { id: "en", name: "English" },
        { id: "bn", name: "Bengali" },
        { id: "te", name: "Telugu" },
        { id: "hi", name: "Hindi"}
      ]
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "profileUpdate/GetmeTenant",
      tenantLanguage: "tenant/GetTenantLanguage",
      tenantPreferences: "tenant/GetTenantPreferences"
    }),
    userLogo() {
      if (JSON.parse(sessionStorage.userLogin)["userLogo"]) {
        return JSON.parse(sessionStorage.userLogin)["userLogo"];
      } else {
        return "img/avatars/6.jpg";
      }
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    }
  },
  mounted() {
    if (this.userRole === "Tenant") {
      this.getPreference(this.userId).then(result => {
        if (result.status === 1) {
          if (
            this.tenantPreferences.languages &&
            this.tenantPreferences.languages.length > 0
          ) {
            this.tenantPreferences.languages.map(obj => {
              this.selectedLanguage.push({
                id: obj,
                name: this.langObj[obj]
              });
            });
            this.defaultLanguage = this.tenantPreferences.defaultLanguage;
            this.lightMode = this.tenantPreferences.lightMode;
            this.enableManufacturer = this.tenantPreferences.enableManufacturer;
          }
        }
      });
    }
    this.$store.dispatch("profileUpdate/fetchmeTenant");
  },
  methods: {
    ...mapActions({
      updateProfile: "profileUpdate/updateTenant",
      changePassword: "profileUpdate/UpdatePassword",
      updatePreference: "tenant/updateTenantPreferences",
      getPreference: "tenant/getTenantPreferences"
    }),
    onSaveLanguage() {
      let languages = [];
      if (this.selectedLanguage && this.selectedLanguage.length > 0) {
        this.selectedLanguage.map(obj => {
          languages.push(obj.id);
        });
      }
      let payload = {
        id: this.userId,
        data: {
          languages: languages,
          defaultLanguage: this.defaultLanguage ? this.defaultLanguage : "en",
          lightMode: this.lightMode,
          enableManufacturer: this.enableManufacturer
        }
      };
      this.updatePreference(payload).then(result => {
        this.$toasted.success("Tenant preferences updated.");
        if (result.status === 1) {
          this.getPreference(this.userId);
        }
      });
    }
  }
};
</script>
<style scoped>
.Account-card {
  background-color: #ffffff;
  padding-top: 18px;
}
/* p {
  font-size: 13px;
} */
.v-btn{
  text-transform: capitalize;
}
.center {
  margin-left: auto;
  margin-right: auto;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

th,
td {
  padding: 8px;
}
th {
  width: 20%;
}
</style>
